// eslint-disable-next-line import/prefer-default-export
export const COMMUNITYUSERS_SELECTOR_KEY = 'chats/connctions';
